const css = `.NQFe6a__container:hover{cursor:pointer;background-color:#f1f2f4}.NQFe6a__borderContainer{border-bottom:1px solid #e4e8eb}.NQFe6a__abovePill{color:#f65c8c;background-color:#fbbed180;border-radius:4px;padding:2px 8px}.NQFe6a__numberPill{color:#448ee1;background-color:#a1c6f080;border-radius:4px;padding:2px 8px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"borderContainer":"NQFe6a__borderContainer","abovePill":"NQFe6a__abovePill","container":"NQFe6a__container","numberPill":"NQFe6a__numberPill"};
